<template>
  <div class="header">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
      <el-menu-item index="1">
        <span @click="logouts()">退出登录</span>
      </el-menu-item>  
      <el-menu-item index="3">
        <span @click="centerDialogVisible = true">修改密码</span>
      </el-menu-item> 
    </el-menu>
    <el-dialog title="修改密码" :visible.sync="centerDialogVisible" width="50%" center>
      <span style="padding:100px">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="账号名称">
            <el-input v-model="form.loginname"  :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="原始密码">
            <el-input v-model="form.passwored" show-password placeholder="请输入原始密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="form.newpasswored" show-password placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input v-model="form.repasswored" show-password placeholder="请输入确认密码"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goSubmit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template> 
<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
export default {
  name: "myHeader",
  props: [],
  data() {
    return {
      activeIndex: "1",
      centerDialogVisible: false,
      form: {
        loginname: "",
        passwored: "",
        newpasswored: "",
        repasswored: ""
      }
    };
  },
  mounted() { 
    this.form.loginname=this.loginname;
    console.log(this.loginname);
  },
  computed: {
    ...mapState(["urls", "comhttp","custname","loginname"])
  },
  methods: {
    ...mapActions(["logout"]),
    historyBack() {
      history.back();
    },
    clickRight() {
      this.$emit("click-right", "");
    },
    logouts() {
      this.logout();
      window.location.href = this.comhttp + "j_spring_security_logout";
    },
    goSubmit() {
      if (this.form.passwored == "") {
        this.$alert("请输入原始密码", "修改提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return;
      }
      if (this.form.newpasswored == "") {
        this.$alert("请输入新密码", "修改提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return;
      }
      if (this.form.repasswored == "") {
        this.$alert("请输入确认密码", "修改提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return;
      }
      if (this.form.newpasswored !== this.form.repasswored) {
        this.$alert("两次输入密码不一样", "修改提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return;
      }

      axios
        .get("/rf/custinfo!savePass.action", {
          params: {
            oldpass: this.form.passwored,
            newpass: this.form.newpasswored
          }
        })
        .then(response => {
          if (response.data.state === 0) {
            this.$alert("修改成功！", "修改提示", {
              confirmButtonText: "确定",
              callback: action => {
                this.centerDialogVisible=false;
              }
            }); 
          } else {
            this.$alert("修改失败！", "修改提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        })
        .catch(function(error) {
          window.console.log(error);
        });
    }
  }
};
</script>

<style lang="scss">
@import "../assets/basic.scss";
//控制导航从右排列
.header {
  .el-menu-item {
    float: right !important;
  }
}
</style>